export const QUERY_BULK_CALCULATE_1099_BATCH =
  "QUERY_BULK_CALCULATE_1099_BATCH";
export const QUERY_BULK_CALCULATE_1099_BATCH_SUMMARY =
  "QUERY_BULK_CALCULATE_1099_BATCH_SUMMARY";
export const BULK_CALCULATE_1099_BATCH_LIST = "BULK_CALCULATE_1099_BATCH_LIST";
